/** English source dictionary. `bn.ts` must mirror these keys exactly. */
export const en = {
  common: {
    momonos: 'Momonos',
    back: 'Back',
    next: 'Next',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    done: 'Done',
    retry: 'Retry',
    loading: 'Loading…',
    search: 'Search',
    total: 'Total',
    subtotal: 'Subtotal',
    vat: 'VAT',
    discount: 'Discount',
    quantity: 'Quantity',
    calories: 'cal',
    veg: 'Veg',
    bestseller: 'Bestseller',
    soldOut: 'Sold out',
    offline: 'Connection lost — reconnecting…',
  },
  kiosk: {
    tapToStart: 'Touch to order',
    welcome: 'Welcome to Momonos',
    chooseLanguage: 'Choose your language',
    startOrder: 'Start Order',
    dineIn: 'Dine In',
    takeaway: 'Takeaway',
    howToEat: 'Where will you eat?',
    addToCart: 'Add to Cart',
    yourOrder: 'Your Order',
    emptyCart: 'Your cart is empty',
    checkout: 'Checkout',
    promoCode: 'Promo code',
    apply: 'Apply',
    payNow: 'Pay',
    stillThere: 'Still there?',
    idleWarning: 'Your order will reset in {seconds} seconds',
    continueOrdering: 'Continue ordering',
    startOver: 'Start over',
  },
  customize: {
    title: 'Customize',
    spiceLevel: 'Spice level',
    spice0: 'No spice',
    spice1: 'Mild',
    spice2: 'Medium',
    spice3: 'Hot',
    sauces: 'Sauces',
    extras: 'Extras',
    specialNote: 'Special instructions',
    notePlaceholder: 'e.g. no onion',
  },
  payment: {
    choose: 'How would you like to pay?',
    cash: 'Cash',
    bkash: 'bKash',
    nagad: 'Nagad',
    rocket: 'Rocket',
    card: 'Card',
    payAtCounter: 'Pay at the counter',
    payAtCounterHelp: 'Show this order number at the counter to pay and collect.',
    processing: 'Processing…',
  },
  orderStatus: {
    yourNumber: 'Your order number',
    estimatedWait: 'Estimated wait',
    minutes: '{count} min',
    received: 'Order received',
    preparing: 'Preparing your food',
    ready: 'Ready for pickup!',
    delivered: 'Enjoy your meal',
    thankYou: 'Thank you!',
    scanToTrack: 'Scan to track your order',
  },
  tv: {
    preparing: 'Preparing',
    ready: 'Ready',
    collectNow: 'Please collect',
  },
  qr: {
    tableLabel: 'Table {table}',
    yourName: 'Your name',
    yourPhone: 'Phone (optional)',
    phoneHelp: "We'll only use it to notify you about this order.",
    placeOrder: 'Place order',
    orderPlaced: 'Order placed',
  },
  errors: {
    VALIDATION_FAILED: 'Please check your order and try again.',
    ITEM_UNAVAILABLE: 'Sorry, an item in your cart just sold out.',
    PRICE_CHANGED: 'Prices were updated. Please review your order.',
    COUPON_INVALID: 'This promo code is not valid.',
    COUPON_EXPIRED: 'This promo code has expired.',
    COUPON_MIN_ORDER: 'Your order is below the minimum for this promo code.',
    COUPON_EXHAUSTED: 'This promo code has been fully used.',
    RATE_LIMITED: 'Too many attempts. Please wait a moment.',
    SPIN_NOT_ELIGIBLE: 'This number has already played recently. Come back soon!',
    INTERNAL: 'Something went wrong. Please ask our staff for help.',
    NETWORK: 'No connection. Please try again.',
  },
} as const

/**
 * `as const` above gives us literal key paths for autocomplete, but a
 * translation must not be forced to equal the English literal — so widen the
 * leaves back to `string` before other locales are typed against it.
 */
type WidenStrings<T> = {
  [K in keyof T]: T[K] extends string ? string : WidenStrings<T[K]>
}

export type Dictionary = WidenStrings<typeof en>
